import { render, staticRenderFns } from "./group-polarBar.md?vue&type=template&id=3a8945c9&"
import script from "./group-polarBar.md?vue&type=script&lang=js&"
export * from "./group-polarBar.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a8945c9')) {
      api.createRecord('3a8945c9', component.options)
    } else {
      api.reload('3a8945c9', component.options)
    }
    module.hot.accept("./group-polarBar.md?vue&type=template&id=3a8945c9&", function () {
      api.rerender('3a8945c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/PolarBar/group-polarBar.md"
export default component.exports